<template>
  <v-navigation-drawer v-model="drawer" app dark temporary>
    <v-list-item>
      <v-list-item-avatar class="avatar-border">
        <img :src="require('../../assets/logoDark.png')" alt="Logo" />
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="appTitle">
          {{ applicationName }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider />

    <v-list>
      <v-list-item
        v-for="(link, i) in links"
        :key="'link' + i"
        :to="link.to"
        :href="link.href"
        @click="onClick($event, link)"
      >
        <v-list-item-title v-text="link.text" />
      </v-list-item>

      <v-list-item href="#gallery" @click="goToGallery($event)">
        <v-list-item-title>Gallery</v-list-item-title>
      </v-list-item>

      <v-list-item
        class="ml-5"
        @click="openGalleryCategory($event, category)"
        v-for="(category, i) in categories"
        :key="'category' + i"
      >
        <v-list-item-title>{{ category.displayName }}</v-list-item-title>
      </v-list-item>

      <v-list-item class="pa-2 mt-2">
        <v-btn block light @click="closeDrawer">
          <v-icon left>mdi-close-thick</v-icon>
          Close
        </v-btn>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";

export default {
  name: "Drawer",
  computed: {
    ...mapGetters("pictures", ["categories"]),
    ...mapState(["applicationName", "links"]),
    drawer: {
      get() {
        return this.$store.state.navigationDrawer;
      },
      set(val) {
        this.setDrawer(val);
      },
    },
  },
  methods: {
    ...mapMutations(["setDrawer"]),
    ...mapMutations("pictures", ["setActiveCategory"]),
    goToGallery(e) {
      e.stopPropagation();
      this.$vuetify.goTo("#gallery");
      this.setDrawer(false);
    },
    onClick(e, item) {
      e.stopPropagation();

      if (item.to || !item.href) return;

      this.$vuetify.goTo(item.href.endsWith("#") ? 0 : item.href);
      this.setDrawer(false);
    },
    openGalleryCategory(e, category) {
      this.goToGallery(e);
      this.setActiveCategory(category);
    },
    closeDrawer() {
      this.setDrawer(false);
    },
  },
};
</script>

<style scoped>
.appTitle {
  font-family: "Aller-Display", sans-serif;
}
</style>
